// extracted by mini-css-extract-plugin
module.exports = {"svg":"GitIcon_svg__3q1B_"};